import * as React from 'react';
import { Textarea, Checkbox, TextInput } from "soprasteria-ui-library";
import { IOrthodonticReferral } from '../../../../models/IOrthodonticReferral';
import { OrthodonticReferralFileSection } from './OrthodonticReferralFileSection';
import { TREATMENT1_TYPEID } from "../../../../utils/OrthodonticReferralConstants";

interface IOrthodonticReferralOtherInformation {
    orthodonticReferral: IOrthodonticReferral;
    isFetchingOrthodonticReferral: boolean;
    changeSuccessMessage: (message: string) => void;
    changeErrorMessage: (message: string) => void;
    getOrthodonticReferral: (id: number, refresh: boolean) => void;
}

export const OrthodonticReferralOtherInformation: React.FunctionComponent<IOrthodonticReferralOtherInformation> = ({ orthodonticReferral, isFetchingOrthodonticReferral, changeSuccessMessage, changeErrorMessage, getOrthodonticReferral }) => {

    const [isTreatmentStartedInAnotherCounty, setIsTreatmentStartedInAnotherCounty] = React.useState<boolean>(orthodonticReferral.isTreatmentStartedInAnotherCounty ?? false);

    return (
        <>
            <div className="row">
                <h5 className="col-12">Annat</h5>
                {
                    orthodonticReferral.orthodonticReferralTypeId == TREATMENT1_TYPEID ?
                        <div className="col-6">
                            {
                                orthodonticReferral.canEdit ?
                                    <Checkbox name="isTreatmentStartedInAnotherCounty"
                                        id="isTreatmentStartedInAnotherCounty"
                                        label="Tandreglering startad utanför Region Stockholm"
                                        value="true"
                                        checked={orthodonticReferral.isTreatmentStartedInAnotherCounty}
                                        onChange={() => setIsTreatmentStartedInAnotherCounty(!isTreatmentStartedInAnotherCounty)}
                                        inlineLabel
                                        withColumn
                                        disabled={!orthodonticReferral.canEdit}
                                    />
                                    :
                                    isTreatmentStartedInAnotherCounty
                                        ?
                                        <TextInput
                                            label="Tandreglering startad utanför Region Stockholm"
                                            name="readonlyIsTreatmentStartedInAnotherCounty"
                                            defaultValue="Ja"
                                            readonly
                                            inlineLabel
                                        />
                                        : null
                            }
                            {
                                isTreatmentStartedInAnotherCounty ?
                                    <Textarea name="informationAboutExternalCareProvider"
                                        label="Information om ursprunglig behandlande mottagning"
                                        defaultValue={orthodonticReferral.informationAboutExternalCareProvider}
                                        readonly={!orthodonticReferral.canEdit}
                                        rows={5} inlineLabel required />
                                    : null
                            }
                        </div>
                        : null
                }
                {
                    !isFetchingOrthodonticReferral ?
                        <OrthodonticReferralFileSection orthodonticReferral={orthodonticReferral} changeSuccessMessage={changeSuccessMessage} changeErrorMessage={changeErrorMessage} getOrthodonticReferral={getOrthodonticReferral}/>
                        : null
                }
            </div>
            <hr />
        </>
    )
}